import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { genUID } from '@entrata/utils'

const st0 = css`
  fill: #e2edf6;
`
const st1 = css`
  fill: #ffffff;
`
const st2 = css`
  fill: #ffefe1;
`
const st3 = css`
  fill: #273e4f;
`

class RentItems extends React.Component {
  constructor(props) {
    super(props)
    this.titleId = genUID()
  }

  render() {
    const {
      style = {},
      size = 16,
      height,
      width,
      svgRef,
      title,
      ...props
    } = this.props

    return (
      <svg
        viewBox='0 0 104 104'
        height={height || size}
        width={width || size}
        ref={svgRef}
        aria-labelledby={title ? this.titleId : undefined}
        style={{
          pointerEvents: 'none',
          fill: 'currentColor',
          ...style,
        }}
        {...props}
      >
        {title ? <title id={this.titleId}>{title}</title> : null}
        <path
          css={st0}
          d='M58.1,44.9c0,0-18.1-22.7-25.9-22.5c-7.8,0.3-25.6,13-27.6,19.8c-2,6.8-1.3,47.5,0.8,51.3 c1.7,2.9,25.1,2.6,25.1,2.6s21.3,2,25.9-2.6S58.1,44.9,58.1,44.9z M31.2,42.1c-2.6,0-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6 c2.6,0,4.6,2.1,4.6,4.6S33.7,42.1,31.2,42.1z'
        />
        <path css={st1} d='M50,85.5H13.2V50.7H50V85.5z' />
        <path
          css={st2}
          d='M71.9,39.1c4-3.6,6.5-8.8,6.5-14.6c0-10.8-8.8-19.6-19.6-19.6s-19.6,8.8-19.6,19.6s8.8,19.6,19.6,19.6 c0.6,0,1.2,0,1.8-0.1l9.2,22.9l-5.9,3.2l2.9,6.8l6.6-2.9l2.5,5.9l-7.4,4l2.7,6.8l8.5-3.5l3.1,6.2l12.5-6 C95.3,87.6,77.5,49.5,71.9,39.1z M51.5,24.5c0-4,3.3-7.3,7.3-7.3s7.3,3.3,7.3,7.3s-3.3,7.3-7.3,7.3S51.5,28.5,51.5,24.5z'
        />
        <path
          css={st3}
          d='M11.3,51.1v34.2c0,1,0.8,1.8,1.8,1.8h36.4c1,0,1.8-0.8,1.8-1.8V51.1c0-1-0.8-1.8-1.8-1.8H13 C12.1,49.4,11.3,50.2,11.3,51.1z M14.8,52.9h32.9v30.7H14.8V52.9z M97.3,87.4l-22-48.2c5.7-6.4,7.4-15.8,3.6-24 C73.9,4,60.7-0.9,49.5,4.2c-2,0.9-3.9,2.1-5.5,3.5c-1-0.1-2-0.2-3-0.2c-10.5,0-19.1,7.6-19.2,17L8.1,34.8c-3.5,2.6-5.6,6.7-5.6,11 V90c0,4.3,3.5,7.8,7.8,7.8h41.9c4.3,0,7.8-3.5,7.8-7.8V48.4l7.9,17.4l-5.6,2.5c-0.9,0.4-1.2,1.5-0.9,2.3l3.3,7.2 c0.4,0.9,1.4,1.3,2.3,0.9l5.6-2.5l1.3,2.9l-7,3.2c-0.9,0.4-1.3,1.4-0.9,2.3l3.3,7.2c0.4,0.9,1.4,1.3,2.3,0.9l7-3.2l2.5,5.4 c0.4,0.9,1.4,1.3,2.3,0.9l13-6C97.3,89.3,97.7,88.3,97.3,87.4z M41,11c-2.4,3.2-3.9,6.9-4.4,10.8c-3.4-1.8-7.5-1.8-10.9,0 C27.3,15.7,33.5,11,41,11z M56.4,90c0,2.3-1.9,4.2-4.2,4.2H10.3C7.9,94.3,6,92.4,6,90V45.8c0-3.2,1.5-6.3,4.1-8.2l12.3-9.1 c0.6,2.2,1.7,4.4,3.1,6.3c-0.4,0.8-0.6,1.7-0.6,2.7c0,3.4,2.8,6.2,6.2,6.2s6.2-2.8,6.2-6.2s-2.8-6.2-6.2-6.2c-1.2,0-2.3,0.3-3.2,0.9 c-1.3-1.9-2.1-4-2.5-6l0.7-0.6c1.5-1.1,3.2-1.6,4.9-1.6c1.7,0,3.4,0.5,4.9,1.6l0.5,0.3c0.2,2.6,0.8,5.2,2,7.7 c3.4,7.4,10.3,12,17.8,12.8V90z M31.3,35.7c-0.3-0.3-0.6-0.5-0.9-0.8c0.3-0.1,0.6-0.2,0.9-0.2c1.5,0,2.8,1.2,2.8,2.8 s-1.2,2.8-2.8,2.8c-1.3,0-2.5-1-2.7-2.3c0.2,0.2,0.4,0.3,0.6,0.5c0.3,0.3,0.7,0.4,1.1,0.4c0.5,0,1-0.2,1.4-0.7 C32.2,37.4,32,36.3,31.3,35.7z M83.6,91.7L81.8,88l-0.7-1.6l-0.7-1.6l-1.6,0.7l-1.6,0.7l-5.4,2.5l-1.8-4l5.4-2.5l1.6-0.7l1.6-0.7 l-0.7-1.6l-0.7-1.6l-1.3-2.9l-0.7-1.6l-0.7-1.6l-1.6,0.7L71.1,73l-4,1.8l-1.8-4l4-1.8l1.6-0.7l1.6-0.7l-0.7-1.6L71,64.3l-8.2-18 L62,44.6L61.3,43c-0.6,0.1-1.1,0.1-1.7,0.1c-0.1,0-0.1,0-0.2,0c-0.5,0-1.1,0-1.6,0c-0.1,0-0.2,0-0.3,0c-0.5,0-1-0.1-1.5-0.2 c-6-0.9-11.5-4.8-14.2-10.7c-0.5-1.1-0.9-2.2-1.1-3.3c-0.2-0.8-0.4-1.7-0.4-2.5c-0.1-0.8-0.1-1.5-0.1-2.3c0.1-4.7,1.9-9.2,5.1-12.6 c4,1,7.5,3.3,9.6,6.2c-3.4,2-4.8,6.3-3.1,9.9c1.8,3.9,6.4,5.6,10.3,3.8c3.9-1.8,5.6-6.4,3.8-10.3c-1.4-3-4.4-4.7-7.5-4.5 c-2.1-3.4-5.7-6.3-9.9-7.8c0.8-0.5,1.7-1,2.6-1.5c9.4-4.3,20.5-0.1,24.8,9.2c2.9,6.5,1.9,13.7-2.1,19c-0.4,0.5-0.8,1-1.2,1.5 c-0.4,0.5-0.9,0.9-1.3,1.3l0.8,1.6l0.8,1.7l20.8,45.5L83.6,91.7z M60,20.4c1.1,0.3,2.1,1.1,2.6,2.3c1,2.1,0,4.7-2.1,5.6 s-4.7,0-5.6-2.1c-0.9-1.9-0.2-4.2,1.6-5.3c0.3,1,0.5,1.9,0.5,2.9c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8C60.5,22.6,60.3,21.5,60,20.4z M19.8,60.6h10.9c1,0,1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8H19.8c-1,0-1.8,0.8-1.8,1.8S18.8,60.6,19.8,60.6z M42.6,65.4H19.8 c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8h22.9c1,0,1.8-0.8,1.8-1.8S43.6,65.4,42.6,65.4z M42.6,71.4H19.8c-1,0-1.8,0.8-1.8,1.8 s0.8,1.8,1.8,1.8h22.9c1,0,1.8-0.8,1.8-1.8S43.6,71.4,42.6,71.4z'
        />
      </svg>
    )
  }
}

RentItems.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  svgRef: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
export { RentItems }
